<?xml version="1.0" encoding="UTF-8"?>
<svg width="3px" height="20px" viewBox="0 0 3 20" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <title>pipe-light</title>
    <defs>
        <rect id="path-1" x="0" y="0" width="1" height="18"></rect>
    </defs>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="Click-to-Pay-Styles-for-UI-Display" transform="translate(-3735.000000, -769.000000)">
            <g id="button_dark_v3.1_178x32" transform="translate(3693.000000, 763.000000)">
                <g id="v4_mark_light_S_15px" transform="translate(14.500000, 6.500000)">
                    <g id="pipe-light" transform="translate(28.500000, 0.500000)">
                        <mask id="mask-2" fill="white">
                            <use xlink:href="#path-1"></use>
                        </mask>
                        <g id="Pipe-background"></g>
                        <rect id="Pipe" fill="#FFFFFF" mask="url(#mask-2)" x="0" y="1.5" width="1" height="15" rx="0.5"></rect>
                    </g>
                </g>
            </g>
        </g>
    </g>
</svg>
